import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import InputGroup from '@/components/forms/core/InputGroup';

interface RadioOption {
  value: string;
  title: string;
}

interface RadioGroupProps extends UseControllerProps {
  id: string;
  label: string;
  options: RadioOption[];
  required?: boolean;
  horizontal?: boolean;
  onChange?: (value: string) => void;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ id, label, options, required = false, horizontal = false, onChange, ...props }) => {
  const { field } = useController(props);

  return (
    <InputGroup id={props.name} label={label} required={required}>
      <div className={`flex ${horizontal ? 'flex-row gap-5' : 'flex-col gap-2'}`}>
        {options.map((option) => (
          <label key={option.value} className="inline-flex items-center gap-2">
            <input
              id={id}
              type="radio"
              name={field.name}
              value={option.value}
              checked={field.value === option.value}
              onChange={(e) => {
                field.onChange(e.target.value);
                if (onChange) {
                  onChange(e.target.value);
                }
              }}
              className="radio-input"
            />
            <span>{option.title}</span>
          </label>
        ))}
      </div>
    </InputGroup>
  );
};
